import tempMeeApi from '../../../apis/tempMee';

// Allowed only while the cycle computes to pending or active. Also 409s if the
// new dates would make it complete, or would regress an active cycle to pending.
export const updateCycle = async (cycleId, payload) => {
  const response = await tempMeeApi.put(
    `/awards-service-api/admin/cycles/${cycleId}`,
    payload,
  );

  return response.data;
};
